import { useLang } from "../i18n";
import { WHATSAPP_NUMBER } from "../config";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const { t } = useLang();
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hola! Quiero alquilar una moto en Tenerife.")}`;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
      aria-label="WhatsApp">
      <span className="hidden sm:block opacity-0 group-hover:opacity-100 transition-opacity bg-white border-2 border-topacio-ink text-topacio-ink text-xs font-bold px-3 py-2 rounded-lg shadow-[3px_3px_0_0_#111]">
        {t.wa}
      </span>
      <span className="w-14 h-14 rounded-full bg-[#25D366] border-2 border-topacio-ink flex items-center justify-center shadow-[4px_4px_0_0_#111] hover:-translate-y-1 hover:shadow-[6px_6px_0_0_#111] active:translate-y-0 active:shadow-none transition-[transform,box-shadow]">
        <FaWhatsapp className="w-7 h-7 text-white" />
      </span>
    </a>
  );
}
